'use strict';

import ngResource from 'angular-resource';

class DeviceErrorService {
  constructor($resource) {
    'ngInject';
    this.api = $resource(
      '/api/device_error/:id', {id: '@id'},
      {
        index: {method: 'GET', isArray: true},
        show: {method: 'GET', isArray: false}
      }
    );

    this.oem_api = $resource(
      '/api/oem/device_error', {},
      {index: {method: 'GET', isArray: false}}
    );
  }
}

export default angular.module('leptonApp.DeviceErrorService', ['ngResource'])
  .service('DeviceErrorService', ['$resource', DeviceErrorService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/device_error/device_error.service.js